import { Observable } from './druid/./druid/Observable';
import { interval as staticInterval } from './druid/./druid/observable/interval';

Observable.interval = staticInterval;

declare module './druid/./druid/Observable' {
  namespace Observable {
    export let interval: typeof staticInterval;
  }
}